import { useSelector } from 'react-redux';
import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { useScreenResolution } from '@app/hooks';
import { selectBuyMore, selectLocale, selectPlanInfo } from '@app/redux';
import { parseDateStringWithoutTime } from '@app/utils';

import ProductList from './ProductList';
import { formatDate } from '../utils/formatDate';

import styles from './styles.module.scss';

const BrowseContent: React.FC = () => {
  const { t } = useTranslation('BuyMore');

  const { offers, loading } = useSelector(selectBuyMore);
  const {
    data: {
      usage: { endDate },
    },
  } = useSelector(selectPlanInfo);
  const {
    locale: { displayLanguage },
  } = useSelector(selectLocale);

  const usageResetDate =
    endDate && displayLanguage
      ? formatDate(displayLanguage.replace('_', '-') ?? '', parseDateStringWithoutTime(endDate))
      : null;

  const { isSmall, isExtraSmall } = useScreenResolution();
  const isMobile = isSmall || isExtraSmall;

  const disclosure =
    offers && offers.length > 0 && offers[0].disclosure ? offers[0].disclosure : t('Browse.content.disclosure');

  return (
    <div>
      <header className={styles['header']}>
        <Txt variant={isMobile ? 'heading4' : 'heading2'}>{t('Browse.content.title')}</Txt>
        <Txt data-cy="buy-more-modal-text" variant={isMobile ? 'bodySmallRegular' : 'bodyLargeRegular'}>
          {t('Browse.content.notice.first')}
          {Boolean(usageResetDate) && (
            <span className={styles['withParentheses']}>
              <Txt
                data-cy="buy-more-bill-cycle-date"
                component="span"
                variant={isMobile ? 'bodySmallBold' : 'bodyLargeBold'}
              >
                {usageResetDate}
              </Txt>
            </span>
          )}
          {t('Browse.content.notice.second')}
        </Txt>
      </header>
      <div className={styles['container']}>
        <ProductList loading={loading} products={offers} />
        <Txt variant="smallRegular" color="subtle">
          {disclosure}
        </Txt>
      </div>
    </div>
  );
};

export default BrowseContent;
